// export const API_URL = "http://127.0.0.1:8000/api/"
// export const API_URL = "https://api.myalertness.com/api/"
export const API_URL = "https://mydemoview.info/thirdpillar/index.php/api/"